export default __webpack_public_path__ + "static/lb-07-608b7cf603a4cdb85f6d14a4d0bab9f1.webp";